module.exports = __webpack_public_path__ + "static/media/step3.a2e1deac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/tbank/step3.jpg
// module id = 712
// module chunks = 0